import React from 'react';
import { getIconWithTooltip } from './helper';
import { Edit, EditOff } from '@mui/icons-material';
import FieldIcon from '../../b2b-common/FieldIcon';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const AccessLevel = ({ readOnly = false, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <FieldIcon label={t('Access Level')} icon={!readOnly ? getIconWithTooltip(Edit, {}, t('Can Edit')) :
            getIconWithTooltip(EditOff, {}, t('Read Only'))} className={className} />
    );
};

export default AccessLevel;